import gql from 'graphql-tag';

export const NetworkStatusLinkQuery = gql`
	query NetworkStatusLinkQuery {
		network {
			status
		}
	}
`;
